import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { getNewProductById } from '../../../../api/product/queries/getNewProductById';
import { INewProduct } from '../../../../interfaces/NewProduct.interfaces';

interface IUseGetNewProductByIdQueryParams {
  productId: string;
  options?: UseQueryOptions<INewProduct, AxiosError>;
}

/**
 * 신품 상세 정보를 조회하는 useQuery 훅
 * @param productId - 조회할 신품의 고유 ID
 * @param options - React Query 옵션
 * @returns useQuery 결과
 */
export const useGetNewProductByIdQuery = ({ productId, options }: IUseGetNewProductByIdQueryParams) => {
  return useQuery<INewProduct, AxiosError>(['new_product_by_id', productId], () => getNewProductById({ productId }), {
    enabled: Boolean(productId),
    ...options,
  });
};
